import React from "react";
import styled from "@emotion/styled";
import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

interface IStyles {
  height?: string;
  fontWeight?: string;
  margin?: string;
  fontSize?: string;
}

interface ButtonLoaderProps extends ButtonProps, IStyles {
  loading?: boolean;
}

const StyledButton = styled(Button)<IStyles>`
  height: ${({ height }) => height ?? "48px"};
  font-weight: ${({ fontWeight }) => fontWeight ?? "500"};
  margin: ${({ margin }) => margin ?? "0px"};
  font-size: ${({ fontSize }) => fontSize ?? "16px"};
  border-radius: 24px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const ButtonLoader: React.FC<ButtonLoaderProps> = ({ loading, children, ...props }) => (
  <StyledButton {...props} disabled={props.disabled || loading}>
    {loading ? <CircularProgress size={24} color="inherit" /> : children}
  </StyledButton>
);
